import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const prefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";
const Flame = `${prefix}/images/icons/flame.svg`;
const FlameGray = `${prefix}/images/icons/flame_gray.svg`;
const FlameBasic = `${prefix}/images/icons/flame_basic.svg`;
const FlameBasicGray = `${prefix}/images/icons/flame_basic_gray.svg`;

const FlameIcon = ({ variant, count, ...rest }) => {
  const renderVariant = () => {
    let src = Flame;
    let alt = "Flame";

    if (variant === "gray") {
      src = FlameGray;
      alt = "Flame Gray";
    }
    if (variant === "basic") {
      src = FlameBasic;
      alt = "Flame Basic";
    }
    if (variant === "basicgray") {
      src = FlameBasicGray;
      alt = "Flame Basic Gray";
    }

    return (
      <Box component="img" sx={{ width: "28px", height: "28px" }} src={src} alt={alt} {...rest} />
    );
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {renderVariant()}

      {count !== undefined && (
        <Typography
          sx={{
            position: "absolute",
            top: "70%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#fff",
            // textShadow:
            // "-0.5px -0.5px 0 #ffce38, 0.5px -0.5px 0 #ffce38, -0.5px 0.5px 0 #ffce38, 0.5px 0.5px 0 #ffce38",
            // color: "#ffce38",
          }}
        >
          {count}
        </Typography>
      )}
    </Box>
  );
};

export default FlameIcon;
